import SectionChild from "~/components/SectionChild";
import SectionTitle from "./__components/section-title";
import TwoCol from "./__components/two-col";
import CoreValueItem from "./__components/core-value-item";
import { Trans, useTranslation } from "react-i18next";
import Hero from '~/components/hero';
import Heading2 from './__components/heading2';
import {  IconName } from '~/components/ui/icon';
import { Img } from 'openimg/react';
import Carousel, { ScrollSnaps } from '~/components/ui/carousel';
import { CarouselItem } from '@repo/ui/components/carousel';
import { buildCanonicalLink, buildMetaFromLoader, buildSeoMeta, getOrigin } from '~/utils/seo';
import { Route } from './+types/gioi-thieu';
import { hostName } from '~/utils/format';
import { serverCallApiCMS } from '~/services/serverCallAPI';
import { IPage } from '~/types/types';
import { useLoaderData } from 'react-router';
import { StructuredDataScript } from '~/components/structured-data-script';
interface MissionConfig {
  icon: IconName;
  label: any;
  description: any;
}
const missionItems: MissionConfig[] = [
  {
    icon: "community",
    label: "mission.items.community.title",
    description: "mission.items.community.description",
  },
  {
    icon: "partner",
    label: "mission.items.partners.title",
    description: "mission.items.partners.description",
  },
  {
    icon: "customer",
    label: "mission.items.customers.title",
    description: "mission.items.customers.description",
  },
  {
    icon: "employee",
    label: "mission.items.employees.title",
    description: "mission.items.employees.description",
  },
];

type Slide = {
  title: string;
  description: string;
  image: string;
  alt?: string;
};

const slides: Slide[] = [
  {
    title: "Lý do khởi đầu từ Tuyên Quang",
    description:
      "Chúng tôi lựa chọn khởi đầu giai đoạn 1 tại Tuyên Quang, bởi đây là thị trường còn nhiều dư địa phát triển, thông tin còn hạn chế, du lịch tăng trưởng và hạ tầng liên tục được đầu tư…",
    image: "/image/about/slide_1.png",
    alt: "Hồ và thành phố Tuyên Quang",
  },
  {
    title: "Bước tiến mới – Công nghệ trong bất động sản",
    description:
      "KLand tiên phong áp dụng công nghệ số hoá vào hoạt động kinh doanh và môi giới bất động sản, giúp quá trình trở nên nhanh chóng, chính xác, riêng tư và hiệu quả.",
    image: "/image/about/slide_2.png",
    alt: "Công nghệ và đô thị số",
  },
  {
    title: "Nền tảng vững chắc hơn 10 năm",
    description: `<h3>Tổng quan kinh nghiệm</h3>
  <p>
    Trước khi khởi động mô hình số hóa, KLand đã có hơn 10 năm kinh nghiệm vững vàng,
    hoạt động ổn định và bền vững trong các lĩnh vực:
  </p>
  <ul class="list-disc">
    <li>Đầu tư, mua bán &amp; sáp nhập doanh nghiệp</li>
    <li>Nhận chuyển nhượng, phát triển và phân phối dự án bất động sản</li>
    <li>Đầu tư dự án đất nền &amp; dự án bất động sản trọng điểm</li>
    <li>Đầu tư du lịch xanh và phát triển bền vững</li>
  </ul>
  <p>
    Chính nền tảng kinh nghiệm – uy tín – tiềm lực này là bệ phóng để KLand tự tin tiên phong
    đưa công nghệ vào bất động sản, tạo nên sự khác biệt và nâng tầm thị trường.
  </p>`,
    image: "/image/about/slide_3.png",
    alt: "Đội ngũ KLand",
  },
];

export async function loader({ request }: Route.LoaderArgs) {
  const contentPage = await serverCallApiCMS<IPage>(
    "/api/v1/web/pages/gioi-thieu"
  ).catch(() => {
    return {
      slug: "",
      description: "",
      content: "",
      seo: {
        title: "Giới thiệu",
        meta_description: "",
        focus_keyphrase: "",
        og_image: [],
      },
      structured: null,
      structuredData: null,
    };
  });

  const origin = getOrigin(request);
  const url = new URL(request.url);
  const canonical = origin ? `${origin}${url.pathname}` : url.pathname;

  return {
    seo: {
      canonical,
      ...contentPage.seo,
    },
    structuredData: contentPage.structuredData ?? null,
  };
}
export const handle = {
  dynamicLinks: (props: any) => {
    return buildCanonicalLink(props?.data?.seo?.canonical || "");
  },
};



export const meta = (args: Route.MetaArgs) => {
  return buildMetaFromLoader(
    args,
    {
      hostName,
      buildSeoMeta,
    },
    (ld) => ld
  );
};
function VisionMissionSection(){
  return (
    <section className="w-full">
      <div className="mx-auto flex flex-col gap-12 px-6 md:px-12 lg:px-[120px] py-16 md:py-24 max-w-[1440px]">
        <div className="flex flex-col items-center gap-4 text-center">
          <SectionTitle >
            Tầm nhìn
          </SectionTitle>
          <p className="max-w-3xl text-sm text-gray-700 md:text-base">
            Đến năm 2035, KLand trở thành đơn vị bất động sản - du lịch hàng đầu
            miền Bắc,dẫn đầu trong:
          </p>
          <div className="grid grid-cols-1 gap-8 mt-8 md:grid-cols-3">
            <div className="flex flex-col items-center p-6 text-center bg-white">
              <img
                src="/image/icons/icons-1.png"
                alt=""
                className="w-20 h-20 mb-4"
              />
              <h3 className="text-lg font-semibold">
                Sàn thương mại
                <br /> bất động sản số hoá
              </h3>
            </div>

            <div className="flex flex-col items-center p-6 text-center bg-white">
              <img
                src="/image/icons/icons-2.png"
                alt=""
                className="w-20 h-20 mb-4"
              />
              <h3 className="text-lg font-semibold">
                Đô thị xanh & bất động sản <br /> bền vững, bất động sản du lịch
              </h3>
            </div>
            <div className="flex flex-col items-center p-6 text-center bg-white">
              <img
                src="/image/icons/icons-3.png"
                alt=""
                className="w-20 h-20 mb-4"
              />
              <h3 className="text-lg font-semibold">
                Đô thị xanh & bất động sảnbền vững, bất động sản du lịch
              </h3>
            </div>
          </div>

          <p>
            KLand hướng tới góp phần nâng tầm vị thế Việt Nam trên bản đồ đầu tư
            và du lịch quốc tế, tạo nên hệ sinh thái <br/> bất động sản - du lịch toàn
            diện, hiện đại và bền vững
          </p>
        </div>
      </div>
    </section>
  );

};


const services = [
  {
    icon: "/image/icons/icons-4.png",
    title: "Mua bán & Chuyển nhượng bất động sản",
    items: [
      "Đồng hành cùng chủ đầu tư trong việc nghiên cứu thị trường, xây dựng chiến lược bán hàng, triển khai marketing và phân phối sản phẩm.",
      "Giúp dự án tiếp cận đúng khách hàng – bán hàng nhanh – tăng hiệu quả tài chính.",
    ],
  },
  {
    icon: "/image/icons/icons-5.png",
    title: "Giải pháp tài chính bất động sản",
    items: [
      "Hỗ trợ chủ sở hữu, nhà đầu tư tiếp cận nguồn vốn linh hoạt, phù hợp với từng nhu cầu.",
      "Tư vấn các gói hợp tác đầu tư, đồng vốn , chia sẻ lợi nhuận, tái cấu trúc dòng tiền.",
    ],
  },
  {
    icon: "/image/icons/icons-6.png",
    title: "Mua bán & Chuyển nhượng bất động sản",
    items: [
      "Kết nối người bán và người mua, đảm bảo giao dịch minh bạch, đúng giá trị.",
      "Hỗ trợ trọn gói từ pháp lý, thủ tục, truyền thông đến chốt giao dịch.",
    ],
  },
  {
    icon: "/image/icons/icons-7.png",
    title: "Đầu tư & Quản lý tài sản",
    items: [
      "Tìm kiếm, đề xuất cơ hội đầu tư bất động sản sinh lời bền vững.",
      "Quản lý, vận hành và khai thác bất động sản để tối ưu giá trị và lợi nhuận dài hạn. ",
    ],
  },
  {
    icon: "/image/icons/icons-8.png",
    title: "Phát triển cộng đồng & Đội ngũ kinh doanh",
    items: [
      "Tạo môi trường cho những người yêu thích bất động sản tham gia cộng tác, gia tăng thu nhập và phát triển bản thân.",
      "Xây dựng hệ sinh thái cộng sự năng động, chuyên nghiệp và nhân văn.",
    ],
  },
];

function KlandServices() {
  return (
    <section className="py-20 bg-[#F2F2F2]" id="services">
      <div className="max-w-6xl px-6 mx-auto">
        <div className="grid grid-cols-1 gap-8 mt-12 sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <Heading2>Dịch vụ của Kland</Heading2>
            <p className="max-w-3xl mx-auto mt-3">
              KLand – Giải pháp toàn diện cho bất động sản: từ dự án, tài chính
              đến đầu tư và cộng đồng. <br /> KLand cung cấp giải pháp toàn diện
              trong lĩnh vực bất động sản, đáp ứng nhu cầu từ phát triển dự án,
              quản lý tài sản đến đầu tư và tài chính.
            </p>
          </div>
          {services.map((service, index) => (
            <div
              key={index}
              className="p-6 transition bg-white border border-gray-200 shadow-sm rounded-2xl hover:shadow-md"
            >
              <div className="flex items-center gap-3 mb-4">
                <img src={service.icon} alt={service.title} className="w-8 h-8" />
                <h3 className="text-lg font-semibold text-gray-900">
                  {service.title}
                </h3>
              </div>
              <ul className="pl-6 space-y-1 text-gray-600 list-disc">
                {service.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
const partners = [
  {
    id: 1,
    title: "Chủ đầu tư dự án",
    description:
      "Đối tác phát triển bất động sản, phân phối hoặc tái cấu trúc sản phẩm dự án.",
  },
  {
    id: 2,
    title: "Chủ sở hữu các giải pháp tài chính",
    description:
      "Các tổ chức, cá nhân có nguồn lực tài chính, cùng tham gia hợp tác đầu tư hoặc khai thác tài sản.",
  },
  {
    id: 3,
    title: "Chủ sở hữu bất động sản",
    description:
      "Người muốn chuyển nhượng, cho thuê hoặc khai thác bất động sản an toàn, đúng giá trị thị trường.",
  },
  {
    id: 4,
    title: "Người mua bất động sản",
    description:
      "Khách hàng có nhu cầu mua, thuê, đầu tư hoặc sử dụng các sản phẩm, dịch vụ bất động sản.",
  },
  {
    id: 5,
    title: "Nhà đầu tư tài chính",
    description:
      "Những cá nhân hoặc tổ chức muốn đầu tư vào các dự án hoặc sản phẩm bất động sản sinh lợi ổn định.",
  },
  {
    id: 6,
    title: "Đối tác chiến lược",
    description:
      "Đơn vị hợp tác trong lĩnh vực tài chính, pháp lý, công nghệ, truyền thông hoặc giáo dục đầu tư.",
  },
];
 function KlandPartners() {
  return (
    <section className="py-20" id="partners">
      <SectionChild className="">
        <Heading2 className="text-center">
          Đối tác Khách hàng của Kland
        </Heading2>
        <p className="max-w-3xl mx-auto mt-3 text-center text-gray-600">
          Mang đến giải pháp toàn diện cho hệ sinh thái bất động sản KLand, đồng
          hành cùng các chủ đầu tư, nhà phát triển dự án và khách hàng trong
          hoạt động đầu tư, quản lý tài sản, tài chính và giao dịch đầu tư.
        </p>

        <div className="grid grid-cols-1 gap-8 mt-12 sm:grid-cols-3">
          <div className="grid grid-cols-1 gap-2">
            {partners.slice(0, 3).map((partner) => (
              <div key={partner.id} className="p-6 transition bg-white">
                <div className="flex items-center gap-3 mb-3 bg-primary-50 rounded-[12px]">
                  <div className="flex items-center justify-center font-semibold rounded-[12px] m-1 w-9 h-9 bg-[#65C9D3] text-white">
                    {partner.id.toString().padStart(2, "0")}
                  </div>
                  <h3 className="text-lg font-semibold text-primary">
                    {partner.title}
                  </h3>
                </div>
                <p className="text-sm leading-relaxed">{partner.description}</p>
              </div>
            ))}
          </div>
          <div>
            <Img
              width={352}
              height={452}
              fit="cover"
              src="/image/about/hero-1.png"
              alt="Đối tác khách hàng KLand"
              className="w-full h-full shadow-sm rounded-xl"
            />
          </div>
          <div className="grid grid-cols-1 gap-2">
            {partners.slice(3, 6).map((partner) => (
              <div key={partner.id} className="p-6 transition bg-white">
                <div className="flex items-center gap-3 mb-3 bg-primary-50 rounded-[12px]">
                  <div className="flex items-center justify-center font-semibold rounded-[12px] m-1 w-9 h-9 bg-[#65C9D3] text-white">
                    {partner.id.toString().padStart(2, "0")}
                  </div>
                  <h3 className="text-lg font-semibold text-primary">
                    {partner.title}
                  </h3>
                </div>
                <p className="text-sm leading-relaxed">{partner.description}</p>
              </div>
            ))}
          </div>
        </div>
      </SectionChild>
    </section>
  );
}
function About() {
  const { t } = useTranslation("about");
  const { structuredData } = useLoaderData<typeof loader>();
  return (
    <div>
      <StructuredDataScript data={structuredData} />
      <Hero
        image="/image/about/hero.png"
        title={t("title")}
        className="max-h-[450px]"
      />
      <div className="bg-[#65C9D31A]">
        <SectionChild className="pt-20">
          <div className="mb-4 text-center md:mb-6 lg:pb-24">
            <Heading2>{t("intro.title")}</Heading2>
            <p className="max-w-4xl mx-auto mt-5 leading-relaxed text-center">
              <Trans
                ns="about"
                i18nKey={"intro.content"}
                components={{
                  span: <span className="text-primary" />,
                }}
              />

              {/* {t("intro.content")} */}
            </p>
          </div>
        </SectionChild>
      </div>

      {/* Vision */}
      <SectionChild className="py-24">
        <TwoCol
          className="lg:gap-[100px]"
          left={
            <div>
              <Img
                width={560}
                height={460}
                src="/image/about/image-1.png"
                alt="Kland team meeting"
                className="w-full shadow-sm rounded-xl"
              />
            </div>
          }
          right={
            <div className="md:justify-self-end">
              <Heading2>{t("vision.title")}</Heading2>
              <p className="mt-4 leading-relaxed">{t("vision.content")}</p>
            </div>
          }
        />
      </SectionChild>

      {/* Todo: */}
      <SectionChild className="text-white bg-primary rounded-2xl">
        <div className="py-8 md:p-8">
          <Carousel
            className="w-full"
            userOptions={{ delay: 5000, playOnInit: false }}
            opts={{ loop: true }}
            slotScrollSnaps={<ScrollSnaps className="mt-3 about-carousel" />}
          >
            {slides.map((slide, idx) => {
              return (
                <CarouselItem className="relative " key={idx}>
                  <div className="flex flex-col justify-between gap-10 md:flex-row md:gap-20 lg:gap-32 pb-7">
                    <div className="w-full">
                      <div className="">
                        <h2 className="text-4xl font-bold font-helve">
                          {slide.title}
                        </h2>
                        <div
                          className="max-w-3xl mt-3 text-sm md:text-base"
                          dangerouslySetInnerHTML={{
                            __html: slide.description,
                          }}
                        ></div>
                      </div>
                    </div>

                    <div className="min-h-[300px] md:min-h-[460px] min-w-2/4">
                      <Img
                        src={slide.image}
                        fit="cover"
                        className="w-full h-full"
                        width={540}
                        height={460}
                        alt={slide.alt || `Slide ${idx + 1}`}
                      />
                    </div>
                  </div>
                </CarouselItem>
              );
            })}
          </Carousel>
        </div>
      </SectionChild>
      <KlandPartners/>
      {/* Kland Services */}
      <KlandServices />
      {/* Mission */}

      <VisionMissionSection />
      <div className="flex flex-col items-center text-center bg-[#006664] text-white rounded-none py-16 px-6 md:px-12 lg:px-[120px] gap-6">
        <SectionTitle className="text-white">Sứ mệnh</SectionTitle>
        <p className="max-w-[1000px] text-sm md:text-2xl font-helve opacity-90">
          KLand cam kết tiên phong ứng dụng công nghệ số hóa vào bất động sản
          và du lịch, kiến tạo những không gian sống, đô thị sinh thái và điểm
          đến nghỉ dưỡng xanh - an toàn - bền vững. Chúng tôi mang đến giải pháp
          giao dịch minh bạch - nhanh chóng - riêng tư, kết nối hiệu quả người
          mua, người bán, nhà đầu tư và cộng đồng; đồng thời lan tỏa giá trị sống
          tỉnh thức và góp phần phát triển kinh tế - xã hội địa phương.
        </p>
      </div>
      {/* Core Values */}
      <SectionChild className="pb-24 mt-14 md:mt-20 lg:mt-28">
        <div className="flex flex-col items-center justify-center gap-10 md:flex-row">
          <div className="md:min-w-[432px] md:h-[580px]">
            <Img
              width={432}
              height={580}
              fit="cover"
              src="/image/about/core-values.png"
              alt="Bắt tay hợp tác"
              className="w-full h-full shadow-sm rounded-xl"
            />
          </div>

          <div className="">
            <SectionTitle align="left">{t("core_values.title")}</SectionTitle>

            <div className="mt-6 space-y-5">
              <CoreValueItem
                order={1}
                title={"Khát vọng"}
                description={
                  "Luôn hướng tới mục tiêu lớn, kiến tạo giá trị lâu dài cho thị trường bất động sản"
                }
              />
              <CoreValueItem
                order={2}
                title={"Kiên định"}
                description={
                  "Bền bỉ theo đuổi tầm nhìn, giữ vững trách nhiệm và cam kết với xã hội, cộng đồng và môi trường"
                }
              />
              <CoreValueItem
                order={3}
                title={"Kề vai"}
                description={
                  "Lấy con người, khách hàng, đối tác, nhân sự và hạnh phúc cộng đồng làm trung tâm, luôn thấu hiểu và đồng hành trong mọi quyết định"
                }
              />
              <CoreValueItem
                order={4}
                title={"Khả thi và kết nối"}
                description={
                  "Giải pháp thực tế, mạng lưới khách hàng, đối tác và ngân hàng"
                }
              />
              <CoreValueItem
                order={5}
                title={"Khác biệt"}
                description={
                  "Đổi mới, sáng tạo, ứng dụng công nghệ và đổi mới để tạo lợi thế tiên phong"
                }
              />
              <CoreValueItem
                order={6}
                title={"Tâm"}
                description={
                  "Triết lý sống và làm việc với cái tâm sáng, nhân văn, tỉnh thức và tử tế"
                }
              />
            </div>
          </div>
        </div>
      </SectionChild>
    </div>
  );
}

export default About;
